import { cadOpType } from "lib/operations/factory";
import { EditDataCommand } from "./edit-base";

export class CylinderEditDataCommand extends EditDataCommand {
    protected opType = cadOpType.EDITCYLINDER;
}